import React, { useState, useRef } from 'react';
import './ViewGallery.css';
import PreviewButton from './PreviewButton'; // Import PreviewButton

// Hardcoded images
import forlandinglogo1 from '../assets/images/Bleach.png';
import forlandinglogo2 from '../assets/images/Code-Geass.png';
import forlandinglogo3 from '../assets/images/Cowboy Bebop.png';
import forlandinglogo4 from '../assets/images/Haikyu.png';
import forlandinglogo5 from '../assets/images/spy-x-family-02.png';
import forlandinglogo6 from '../assets/images/BleexBub.png';
import forlandinglogo7 from '../assets/images/Drifters.png';
import forlandinglogo8 from '../assets/images/GTO.png';
import forlandinglogo9 from '../assets/images/Shigatsu -Wa- Kimi -No -Uso.png';
import forlandinglogo10 from '../assets/images/Tokyo Revengers.png';

const ViewGallery = () => {
  const [activeCard, setActiveCard] = useState(null);
  const [previewAnimeId, setPreviewAnimeId] = useState(null); // Store anime ID for PreviewButton modal
  const galleryRef = useRef(null); // Reference to the gallery container

  const handleCardClick = (card) => {
    setActiveCard(card === activeCard ? null : card); // Toggle active state on click
  };

  const scroll = (direction) => {
    const gallery = galleryRef.current;
    const scrollAmount = direction === 'left' ? -300 : 300;
    gallery.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  // Open the PreviewButton modal
  const handlePreviewClick = (animeId) => {
    setPreviewAnimeId(animeId); // Pass the anime ID to PreviewButton
  };

  // Close the PreviewButton modal
  const closePreview = () => {
    setPreviewAnimeId(null); // Reset the anime ID to close the modal
  };

  return (
    <div className="ViewGallery-container">
      {/* Left arrow */}
      <div
        className="ViewGallery-arrow left"
        onClick={() => scroll('left')}
      >
        <span>&#8592;</span>
      </div>

      {/* Gallery container */}
      <div className="ViewGallery-cards" ref={galleryRef}>
        {/* Existing Hardcoded Cards */}
        <div
          className={`ViewGallery-card card-bleach ${activeCard === 'bleach' ? 'active' : ''}`}
          onClick={() => handleCardClick('bleach')}
        >
          <img src={forlandinglogo1} alt="Bleach" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'bleach' ? 'show' : ''}`}>
            <h3>Bleach</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-code-geass ${activeCard === 'code-geass' ? 'active' : ''}`}
          onClick={() => handleCardClick('code-geass')}
        >
          <img src={forlandinglogo2} alt="Code Geass" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'code-geass' ? 'show' : ''}`}>
            <h3>Code Geass</h3>
          </div>
        </div>

        {/* Added Cards */}
        <div
          className={`ViewGallery-card card-cowboy-bebop ${activeCard === 'cowboy-bebop' ? 'active' : ''}`}
          onClick={() => handleCardClick('cowboy-bebop')}
        >
          <img src={forlandinglogo3} alt="Cowboy Bebop" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'cowboy-bebop' ? 'show' : ''}`}>
            <h3>Cowboy Bebop</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-haikyu ${activeCard === 'haikyu' ? 'active' : ''}`}
          onClick={() => handleCardClick('haikyu')}
        >
          <img src={forlandinglogo4} alt="Haikyu" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'haikyu' ? 'show' : ''}`}>
            <h3>Haikyu</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-spy-x-family ${activeCard === 'spy-x-family' ? 'active' : ''}`}
          onClick={() => handleCardClick('spy-x-family')}
        >
          <img src={forlandinglogo5} alt="Spy x Family" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'spy-x-family' ? 'show' : ''}`}>
            <h3>Spy x Family</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-bleexbub ${activeCard === 'bleexbub' ? 'active' : ''}`}
          onClick={() => handleCardClick('bleexbub')}
        >
          <img src={forlandinglogo6} alt="BleexBub" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'bleexbub' ? 'show' : ''}`}>
            <h3>BleexBub</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-drifters ${activeCard === 'drifters' ? 'active' : ''}`}
          onClick={() => handleCardClick('drifters')}
        >
          <img src={forlandinglogo7} alt="Drifters" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'drifters' ? 'show' : ''}`}>
            <h3>Drifters</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-gto ${activeCard === 'gto' ? 'active' : ''}`}
          onClick={() => handleCardClick('gto')}
        >
          <img src={forlandinglogo8} alt="GTO" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'gto' ? 'show' : ''}`}>
            <h3>GTO</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-shigatsu ${activeCard === 'shigatsu' ? 'active' : ''}`}
          onClick={() => handleCardClick('shigatsu')}
        >
          <img src={forlandinglogo9} alt="Shigatsu Wa Kimi No Uso" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'shigatsu' ? 'show' : ''}`}>
            <h3>Shigatsu Wa Kimi No Uso</h3>
          </div>
        </div>

        <div
          className={`ViewGallery-card card-tokyo-revengers ${activeCard === 'tokyo-revengers' ? 'active' : ''}`}
          onClick={() => handleCardClick('tokyo-revengers')}
        >
          <img src={forlandinglogo10} alt="Tokyo Revengers" className="ViewGallery-image" />
          <div className={`ViewGallery-card-info ${activeCard === 'tokyo-revengers' ? 'show' : ''}`}>
            <h3>Tokyo Revengers</h3>
          </div>
        </div>
      </div>

      {/* Right arrow */}
      <div
        className="ViewGallery-arrow right"
        onClick={() => scroll('right')}
      >
        <span>&#8594;</span>
      </div>

      {/* Render PreviewButton modal if anime is selected */}
      {previewAnimeId && (
        <PreviewButton animeId={previewAnimeId} onClose={closePreview} />
      )}
    </div>
  );
};

export default ViewGallery;
